import KeyValuePair from '@/modules/core/support/KeyValuePair';

/**
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class ApiVersion {
    public id = 0
    public uri = ''
    public version = ''
    public comment = ''

    public get isNew () {
        return !this.id
    }

    public serialize () {
        return {
            version: this.version,
            comment: this.comment,
            url: this.uri,
        }
    }

    public static deserialize (data: KeyValuePair) {
        return Object.assign(new this(), {
            id: data.id,
            comment: data.comment,
            uri: data.uri,
            version: data.version,
        })
    }
}
